// Canonical genre buckets — kept in sync with backend/genres.py CANONICAL_BUCKETS.
// Single source of truth for any UI that picks/displays a genre.
// Alphabetical so the dropdown is stable + scannable.
export const CANONICAL_BUCKETS = [
  'Acapella',
  'Acid Techno',
  'Afro House',
  'Classical',
  'Country',
  'Deep House',
  'Detroit Techno',
  'Drum & Bass',
  'Electronic',
  'Folk',
  'Funk',
  'Future House',
  'Hip-Hop',
  'House',
  'Indie',
  'Industrial Techno',
  'Instrumental',
  'Jazz',
  'Jungle',
  'Latin',
  'Liquid DnB',
  'Metal',
  'Minimal Techno',
  'Neurofunk',
  'Other',
  'Pop',
  'R&B',
  'Reggae',
  'Rock',
  'Soul',
  'Tech House',
  'Techno',
  'Trance',
];
